"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputRelatedEntity = exports.InputRelatedEntity = exports.InputRelatedEntityComponent = exports.InputRelatedEntityDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var use_lang_1 = require("../../hooks/use-lang");
var use_icons_1 = require("../../hooks/use-icons");
var to_array_1 = require("../../utils/to-array");
var use_entities_1 = require("../../hooks/use-entities");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var memo = React.memo;
var lodash_1 = require("lodash");
var theme_1 = require("@shapeable/theme");
var table_1 = require("../elements/table");
var field_container_1 = require("../elements/field-container");
var entity_form_route_1 = require("../entities/entity-form-route");
var entity_form_route_2 = require("../entities/entity-form-route");
var entity_table_actions_1 = require("../entities/entity-table-actions");
var entity_table_controls_cell_1 = require("../entities/entity-table-controls-cell");
var client_1 = require("@apollo/client");
var sprintf_js_1 = require("sprintf-js");
var icon_button_1 = require("../elements/icon-button");
var current_user_can_1 = require("../../utils/current-user-can");
var alert_message_1 = require("../elements/alert-message");
exports.InputRelatedEntityDefaultProps = {
  actionsWidth: 0.2,
  variant: "",
  showControls: true,
  isSingle: false,
  onEdit: function () {},
  onAdd: function () {},
  onRemove: function () {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var TableStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props._maxWidth && "\n      max-width: ".concat(props._maxWidth, ";\n    ");
  }),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var CreateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    text-transform: capitalize;\n  "], ["\n    text-transform: capitalize;\n  "])))
});
var EmptyContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    border-radius: 0px;\n    padding: ", " ", ";\n    border: 2px dotted ", ";\n    align-items: center;\n    justify-content: flex-start;\n        \n    ", "\n\n    ", "\n\n  "], ["\n    display: flex;\n    border-radius: 0px;\n    padding: ", " ", ";\n    border: 2px dotted ", ";\n    align-items: center;\n    justify-content: flex-start;\n        \n    ", "\n\n    ", "\n\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-semi-subtle'), function (props) {
    return props.canCreate && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      cursor: pointer;\n\n      &:hover {\n        border-color: ", ";\n      }\n\n    "], ["\n      cursor: pointer;\n\n      &:hover {\n        border-color: ", ";\n      }\n\n    "])), theme_1.theme.COLOR('line'));
  }, function (props) {
    return !props.canCreate && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme_1.theme.COLOR('text-subtle'));
  })
});
var SaveAlertStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Table: (0, styled_components_1.default)(table_1.Table)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), TableStyles),
  CreateButton: (0, styled_components_1.default)(icon_button_1.CreateIconButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), CreateButtonStyles),
  EmptyContainer: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject([""], [""]))),
  SaveAlert: (0, styled_components_1.default)(alert_message_1.AlertMessage)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), SaveAlertStyles)
};
My.EmptyContainer = styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  ", "\n\n  &:hover {\n    ", " {\n      color: ", ";\n      ", ";\n    }\n  }\n"], ["\n  ", "\n\n  &:hover {\n    ", " {\n      color: ", ";\n      ", ";\n    }\n  }\n"])), EmptyContainerStyles, My.CreateButton, theme_1.theme.COLOR('link-hover'), theme_1.theme.FILL('link-hover'));
var InputRelatedEntityComponent = function (props) {
  var field = props.field,
    className = props.className,
    context = props.context,
    isSortable = props.isSortable,
    onChange = props.onChange,
    entityTypeName = props.entityTypeName,
    onAdd = props.onAdd,
    onEdit = props.onEdit,
    onRemove = props.onRemove,
    actionsWidth = props.actionsWidth,
    isSingle = props.isSingle,
    showControls = props.showControls;
  var _a = __read(React.useState(false), 2),
    hasAdditions = _a[0],
    setHasAdditions = _a[1];
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var icons = (0, use_icons_1.useIcons)();
  var entities = (0, use_entities_1.useEntities)();
  var showModal = context.showModal,
    hideModal = context.hideModal,
    patchEntityData = context.patchEntityData,
    entityData = context.entityData,
    fieldState = context.fieldState;
  var parentDefinition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(context.entityTypeName);
  var data = (0, to_array_1.toArray)(props.data || entityData[field.name] || []);
  var metadata = __assign(__assign({}, field.metadata || {}), {
    parent: {
      type: parentDefinition.label,
      name: fieldState && fieldState.name && fieldState.name.value
    }
  });
  metadata.variant = metadata.variant || metadata.variant || "for".concat(parentDefinition.aliasOf);
  var t = (0, use_lang_1.useLang)();
  if (!field) {
    return null;
  }
  var createTable = definition.createTable;
  var handleChange = function (_a) {
    var name = _a.name,
      value = _a.value;
    if (isSingle) {
      onChange({
        name: name,
        value: (0, lodash_1.first)(value)
      });
    } else {
      onChange({
        name: name,
        value: value
      });
    }
  };
  // responds to a reorder of rows via drag and drop
  var onRowsChange = function (rows) {
    handleChange({
      name: name,
      value: rows
    });
  };
  var _b = __read((0, client_1.useMutation)(definition.delete.mutation), 2),
    deleteMutation = _b[0],
    error = _b[1].error;
  var name = field.name,
    maxWidth = field.maxWidth,
    _c = field.supportedFieldNames,
    supportedFieldNames = _c === void 0 ? [] : _c;
  var value = (0, to_array_1.toArray)(field.value);
  var onRowEdit = function (id, index) {
    var formMetadata = __assign(__assign({}, metadata), {
      index: index
    });
    showModal(React.createElement(entity_form_route_2.EntityUpdateFormRoute, {
      metadata: formMetadata,
      isModal: true,
      onSubmit: function (entity) {
        onEdit({
          entity: entity,
          onChange: handleChange
        });
        hideModal();
      },
      onCancel: function () {
        return hideModal();
      },
      id: id,
      definition: definition
    }), entityTypeName);
  };
  var onRowRemove = function (id) {
    return __awaiter(void 0, void 0, void 0, function () {
      var newValue, data_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!confirm((0, sprintf_js_1.sprintf)(t('Are you sure you wish to remove this %s? This is not reversible.'), definition.label))) return [3 /*break*/, 2];
            newValue = (0, lodash_1.without)(value, id);
            handleChange({
              name: name,
              value: newValue
            });
            return [4 /*yield*/, deleteMutation({
              variables: {
                id: id
              }
            })];
          case 1:
            data_1 = _a.sent().data;
            if (error && error.graphQLErrors && error.graphQLErrors.length) {
              // if there were errors, restore the row
              handleChange({
                name: name,
                value: value
              });
            } else {
              onRemove({
                id: id,
                onChange: handleChange
              });
            }
            _a.label = 2;
          case 2:
            return [2 /*return*/];
        }
      });
    });
  };
  var onRowAdd = function () {
    var formMetadata = __assign(__assign({}, metadata), {
      index: value && value.length && value.length + 1 || 1
    });
    showModal(React.createElement(entity_form_route_1.EntityCreateFormRoute, {
      metadata: formMetadata,
      isModal: true,
      onSubmit: function (entity) {
        var _a;
        // patch the currently displayed entity data
        // this is assumed to be the addition of the new entity under the current field's name
        var patch = (_a = {}, _a["".concat(field.name)] = [entity], _a);
        patchEntityData(patch);
        // add the new item to the actual value - this is assumed to be the current set of ids plus the newly created item
        // this is how the values are actually bound to the main entity (through an array if IDs)
        var newValue = __spreadArray(__spreadArray([], __read(value), false), [entity.id], false);
        handleChange({
          name: name,
          value: newValue
        });
        onAdd({
          entity: entity,
          onChange: handleChange
        });
        setHasAdditions(true);
        hideModal();
      },
      onCancel: function () {
        return hideModal();
      },
      definition: definition
    }), entityTypeName);
  };
  // Map entity data array to cells using configuration, and add actions cell
  // the filter here removes columns which have the same entity type name as the form being displayed
  // this removes the need for variant: "forPerson" etc
  var columns = (0, lodash_1.filter)(createTable ? (0, lodash_1.filter)(createTable(__assign(__assign({}, context), {
    definition: definition,
    variant: metadata.variant
  }))) : [], function (column) {
    return column.entityTypeName !== parentDefinition.aliasOf;
  });
  var supportedColumns = supportedFieldNames.length ? (0, lodash_1.filter)(columns, function (column) {
    return (0, lodash_1.includes)(__spreadArray(__spreadArray([], __read(supportedFieldNames), false), ["actions"], false), column.name);
  }) : columns;
  var tableData = (0, lodash_1.mapValues)((0, lodash_1.keyBy)((0, lodash_1.map)(data, function (entity, index) {
    return __assign(__assign({}, entity), {
      __index: index + 1
    });
  }), function (entity) {
    return entity.id;
  }), function (entity) {
    return {
      id: entity.id,
      cells: __spreadArray(__spreadArray([], __read((0, lodash_1.map)(supportedColumns, function (_a) {
        var name = _a.name,
          renderValue = _a.renderValue;
        return {
          name: name,
          value: renderValue && renderValue({
            entity: entity
          }) || entity
        };
      })), false), [{
        name: "actions",
        value: React.createElement(entity_table_actions_1.EntityTableActions, {
          entityTypeName: entityTypeName,
          onEdit: function () {
            return onRowEdit(entity.id, entity.__index);
          },
          onRemove: function () {
            return onRowRemove(entity.id);
          }
        })
      }], false)
    };
  });
  var addLabel = (0, sprintf_js_1.sprintf)(t('Add %s'), definition.label);
  var availableWidth = showControls ? 1 - actionsWidth : 1;
  var totalWeight = (0, lodash_1.sumBy)(supportedColumns, function (column) {
    return column.weight || 2;
  });
  var controls = React.createElement(entity_table_controls_cell_1.EntityTableControlsCell, {
    countStyle: isSingle ? "single" : "normal",
    entityTypeName: entityTypeName,
    onAdd: onRowAdd,
    count: value && value.length
  });
  var tableColumns = (0, lodash_1.mapValues)((0, lodash_1.keyBy)(supportedColumns, 'name'), function (column) {
    return __assign(__assign({}, column), {
      width: "".concat(availableWidth * 100 * ((column.weight || 2) / totalWeight), "%")
    });
  });
  if (showControls) {
    tableColumns.actions = {
      name: 'actions',
      renderValue: null,
      width: "".concat(100 * actionsWidth, "%"),
      align: "center",
      title: t("Actions"),
      icon: icons.GearsCircle
    };
  }
  var canCreate = (0, current_user_can_1.currentUserCanCreate)(entityTypeName);
  var showAddControls = canCreate && (showControls && !isSingle || isSingle && value.length === 0);
  return React.createElement(My.Container, {
    field: field,
    className: className
  }, !value.length ? canCreate ? React.createElement(My.EmptyContainer, {
    canCreate: true,
    onClick: onRowAdd
  }, React.createElement(My.CreateButton, null, addLabel)) : React.createElement(My.EmptyContainer, {
    canCreate: false
  }, t('You do not have the necessary permissions to create these records.')) : React.createElement(My.Table, {
    variant: "form",
    onRowsChange: onRowsChange,
    header: value.length > 10 && showControls && controls && canCreate,
    footer: showAddControls && controls,
    isSortable: isSortable,
    _maxWidth: maxWidth,
    rows: value,
    columns: tableColumns,
    data: tableData
  }), hasAdditions && React.createElement(My.SaveAlert, {
    isProminent: true,
    text: t("You have added new items and you **_must_ now \"Save Changes\" below** for these items to be saved to this ".concat(parentDefinition.name, "."))
  }));
};
exports.InputRelatedEntityComponent = InputRelatedEntityComponent;
exports.InputRelatedEntityComponent.defaultProps = exports.InputRelatedEntityDefaultProps;
exports.InputRelatedEntity = exports.InputRelatedEntityComponent;
var createInputRelatedEntity = function (props) {
  return React.createElement(exports.InputRelatedEntity, __assign({}, props));
};
exports.createInputRelatedEntity = createInputRelatedEntity;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;